/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';

import { spinnerCss } from './preloader.style';

const PRELOADER_SIZE_NORMAL = 'normal';
const PRELOADER_SIZE_COMPACT = 'compact';
const PRELOADER_COLOR_WHITE = 'white';

export default function Preloader({ blockLevel, color, label, size, ...rest }) {
  const isCompact = size === PRELOADER_SIZE_COMPACT;
  const isWhite = color === PRELOADER_COLOR_WHITE;
  return (
    <div {...rest} css={spinnerCss({ blockLevel, isCompact, isWhite })}>
      <div className="preloader__spinner" />
      {label && <div className="preloader__label">{label}</div>}
    </div>
  );
}

Preloader.propTypes = {
  blockLevel: PropTypes.bool,
  color: PropTypes.oneOf(['default', PRELOADER_COLOR_WHITE]),
  label: PropTypes.node,
  size: PropTypes.oneOf([PRELOADER_SIZE_NORMAL, PRELOADER_SIZE_COMPACT]),
};

Preloader.defaultProps = {
  blockLevel: false,
  color: 'default',
  label: null,
  size: PRELOADER_SIZE_NORMAL,
};
